// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","table__header":"Table_table__header__5mNp3"};